import type { ClientEnvironment } from '@polyai/common/constants/global.constants';

import ENDPOINTS from 'api/endpoints';
import { doGet, doPut } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type {
  RealTimeConfigFormResponse,
  RealTimeConfigResponse,
} from './types';

export const getRealTimeConfig = ({
  accountId,
  projectId,
}: {
  accountId: string;
  projectId: string;
}) => {
  return doGet<RealTimeConfigResponse>(
    generateNextPath(ENDPOINTS.REAL_TIME_CONFIG, {
      accountId,
      projectId,
    }),
    LOGGER_TYPE.JUPITER,
    {
      version: 'v2',
    },
  );
};

export const getRealTimeConfigForm = ({
  accountId,
  projectId,
  clientEnv,
}: {
  accountId: string;
  projectId: string;
  clientEnv: ClientEnvironment;
}) => {
  return doGet<RealTimeConfigFormResponse>(
    generateNextPath(ENDPOINTS.REAL_TIME_CONFIG_CLIENT_ENV, {
      accountId,
      projectId,
      clientEnv,
    }),
    LOGGER_TYPE.JUPITER,
    {
      version: 'v2',
    },
  );
};

export const putRealTimeConfigData = ({
  accountId,
  projectId,
  clientEnv,
  updateType,
  data,
}: {
  accountId: string;
  projectId: string;
  clientEnv: ClientEnvironment;
  updateType: 'manager' | 'builder';
  data: JSON;
}) => {
  return doPut<RealTimeConfigResponse>(
    generateNextPath(
      ENDPOINTS.REAL_TIME_CONFIG_DATA,
      {
        accountId,
        projectId,
        clientEnv,
      },
      {
        update_type: updateType,
      },
    ),
    LOGGER_TYPE.JUPITER,
    { config: data },
    {
      version: 'v2',
    },
  );
};

export const putRealTimeConfigSchema = ({
  accountId,
  projectId,
  clientEnv,
  schema,
}: {
  accountId: string;
  projectId: string;
  clientEnv: ClientEnvironment;
  schema: JSON;
}) => {
  return doPut<RealTimeConfigResponse>(
    generateNextPath(ENDPOINTS.REAL_TIME_CONFIG_SCHEMA, {
      accountId,
      projectId,
      clientEnv,
    }),
    LOGGER_TYPE.JUPITER,
    { schema },
    {
      version: 'v2',
    },
  );
};
